import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import dayjs from 'dayjs'

import tw from '@/styles/tailwind'
import Text from '@/components/Text'
import { Icon } from '@/components/Icon'


// Formato de moneda: "1234.5" -> "1,234.50"
function money(n: any) {
  let partes = Number(n || 0).toFixed(2).split('.')
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return partes.join('.')
}


// Estilos del badge de estatus segun el paso actual.
const STEP_STATUS: Record<string, { label: string; color: string; bg: string; dot: string }> = {
  in_progress: { label: 'En proceso', color: 'amber-600', bg: 'amber-50', dot: 'amber-500' },
  approved:    { label: 'Avalado',    color: 'primary',   bg: 'primary/10', dot: 'primary' },
  rejected:    { label: 'Rechazado',  color: 'red-600',   bg: 'red-50',   dot: 'red-500' },
  pending:     { label: 'Pendiente',  color: 'gray-500',  bg: 'gray-100', dot: 'gray-400' },
}


export default function PaymentRequestRow({ paymentRequest, canReview, isUrgent = false, isSelected = false }: any) {
  const dateStr = dayjs(paymentRequest.date).format('DD/MMM/YYYY')

  let current_approval_stepIndex = paymentRequest?.approvals.findIndex((e: any) => e.status == "in_progress")
  current_approval_stepIndex = current_approval_stepIndex == -1 ? paymentRequest?.approvals.length - 1 : current_approval_stepIndex
  const current_approval_step = paymentRequest?.approvals[current_approval_stepIndex]

  const st = STEP_STATUS[current_approval_step?.status] || STEP_STATUS.pending

  const navigation = useNavigation()

  return (
    <TouchableOpacity
      style={tw.style(
        `bg-white rounded-2xl border border-gray-100 mx-4 mb-4`,
        isSelected && `bg-secondary/5 border-secondary/40`
      )}
      onPress={() => {
        (navigation as any).navigate("Vinte.PaymentRequests.Detail", {
          paymentRequestId: paymentRequest.uuid,
          canReview,
        })
      }}
    >
      {/* Proveedor + monto */}
      <View style={tw`px-4 pt-3 pb-3`}>
        {
          paymentRequest.request_id &&
            <Text style={tw`text-gray-400 text-xs mb-1`}>Folio {paymentRequest.request_id}</Text>
        }
        <View style={tw`row items-start`}>
          {
            isUrgent &&
              <Icon name='flash' color={tw.color('amber-500')} size={16} style={tw`mr-1 mt-0.5`} />
          }
          <Text style={tw`text-gray-900 font-600 flex-1`} numberOfLines={2}>{paymentRequest.provider.name}</Text>
        </View>
        <Text style={tw`text-gray-800 font-500 mt-0.5`}>${money(paymentRequest.total_amount)}</Text>
      </View>

      {/* Concepto + fecha */}
      <View style={tw`px-4 border-t border-gray-100 pt-3 pb-3`}>
        <Text style={tw`text-secondary`}>{paymentRequest.description}</Text>
        <Text style={tw`text-gray-400 text-sm mt-0.5`}>{dateStr}</Text>
      </View>

      {/* Paso actual + estatus */}
      <View style={tw`row justify-between items-center px-4 border-t border-gray-100 py-3`}>
        <Text style={tw`text-gray-500 flex-1 mr-2`} numberOfLines={1}>
          {current_approval_step?.step_name}{current_approval_step?.step_description ? ` · ${current_approval_step.step_description}` : ''}
        </Text>

        <View style={tw.style(`row items-center gap-x-1.5 px-3 py-0.5 rounded-full bg-${st.bg}`)}>
          <View style={tw`h-1.5 w-1.5 rounded-full bg-${st.dot}`} />
          <Text style={tw`text-${st.color} text-sm`}>{st.label}</Text>
        </View>
      </View>
    </TouchableOpacity>
  )
}
